import { defineMessages } from 'react-intl';

const messages = defineMessages({
  buttonText: {
    id: 'Refine.ButtonText',
    defaultMessage: 'Refine',
  },
  selectAll: {
    id: 'Refine.SelectAll',
    defaultMessage: 'Select All',
  },
  resetButton: {
    id: 'Refine.ResetButton',
    defaultMessage: 'Reset',
  },
  cancelButton: {
    id: 'Refine.CancelButton',
    defaultMessage: 'Cancel',
  },
  applyButton: {
    id: 'Refine.ApplyButton',
    defaultMessage: 'Apply',
  },
  searchTermSection: {
    id: 'Refine.SearchTermSection',
    defaultMessage: 'Search Term',
  },
  searchLabel: {
    id: 'Refine.SearchLabel',
    defaultMessage: 'Search…',
  },
});

export default messages;
